import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent, ConfigurationService, LoggerService, SecurityService } from 'saker-core';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent extends BaseComponent {

  // -----------------------------------
  // Model
  // -----------------------------------

  // -----------------------------------
  // Behaviour
  // -----------------------------------
  
  close(result:boolean){
    this.modalService.close(result)
  }

  // -----------------------------------
  // Private
  // -----------------------------------

  //-------------------------------
  // Form
  //-------------------------------

  //-------------------------------
  // System
  //-------------------------------

  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private modalService: NgbActiveModal
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

}
